import { defineComponent as _defineComponent } from 'vue'
import { toRefs, computed } from "vue";
import { mdiInformation, mdiAlert, mdiAlertOctagon, mdiLightningBoltCircle } from "@mdi/js";
import { AssetErrorDetails, AssetErrorSeverity, DecoratedAsset } from "@/types";
import { tFallback } from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'AssetError',
  props: {
    error: null,
    asset: null
  },
  setup(__props: any) {

const props = __props as {
  error: AssetErrorDetails;
  asset: DecoratedAsset;
}

const DEFAULT_SEVERITY = AssetErrorSeverity.Warning;

const ALERT_TYPES: Record<AssetErrorSeverity, string> = {
  0: "info",
  1: "warning",
  2: "error",
  3: "error"
};

const ALERT_ICONS: Record<AssetErrorSeverity, string> = {
  0: mdiInformation,
  1: mdiAlert,
  2: mdiAlertOctagon,
  3: mdiLightningBoltCircle
};



const { error, asset } = toRefs(props);

const alertType = computed(() => {
  return ALERT_TYPES[error.value.error_severity] ?? ALERT_TYPES[DEFAULT_SEVERITY];
});

const alertIcon = computed(() => {
  return ALERT_ICONS[error.value.error_severity] ?? ALERT_ICONS[DEFAULT_SEVERITY];
});

const alertText = computed(() => {
  // Unfortunately, i18n.te doesn't support periods in keys, so all error
  // codes need to be transformed when added to translations and when
  // looked up here.
  const errorCode = error.value.error_code.replace(".", "-");

  const keys = [`errors.${asset.value.config.i18nNamespace}.${errorCode}`, "errors.default"];
  if (asset.value.knownAsset) {
    keys.unshift(`errors.known_assets.${asset.value.knownAsset.name}.${errorCode}`);
  }

  return tFallback(keys, error.value);
});

return { __sfc: true,DEFAULT_SEVERITY, ALERT_TYPES, ALERT_ICONS, props, error, asset, alertType, alertIcon, alertText }
}

})